var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-6 w-6",staticStyle:{"width":"20px","height":"20px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":_vm.color,"stroke-width":"2"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M19 9l-7 7-7-7"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }